export const SCHEDULE_SERVICE_DEALER_TRACK_APPID = '81407961-DC22-4B13-817C-746DAF758687';
export const SCHEDULE_SERVICE_DEALER_TRACK_BOOK_APPOINTMENT_TYPEID = 106;
export const SCHEDULE_SERVICE_DEALER_TRACK_SERVICE_WRITERS_LOOKUP_TYPEID = 101;
export const SCHEDULE_SERVICE_DEALER_TRACK_SERVICE_TYPES_LOOKUP_TYPEID = 99;
